<template>
    <router-view/>
</template>

<style lang="scss">
#app {
    width:100vw;
    height:100vh;
    overflow: hidden;
    background:#f1f1f1;
}
</style>
